<template>
  <div class="p-2 sm:p-3 select-none">
    <div class="flex justify-center flex-wrap">
      <div class="min-w-full sm:min-w-30 max-w-3xl m-2 flex-1">
        <div class="bg-white rounded-lg shadow-card p-4 sm:p-12">
          <!-- If Order From Buildabox -->
          <div v-if="this.order.process != 1">
            <div v-if="canEstimate" class="text-center">
              <h1 class="font-semibold text-2xl lg:text-3xl text-center">
                Order Estimated
              </h1>
              <img alt="check mark" class="w-48 h-48 mx-auto" src="@/assets/icons/check-mark.jpg"/>
            </div>
            <h1 v-else class="font-semibold text-2xl lg:text-3xl text-center">
              Order Estimate
            </h1>
            <div>

              <div v-if="canEstimate" class="flex justify-center mt-3">
                <div class="pr-4 w-1/4">
                  <p class="uppercase font-semibold text-xs opacity-50">Estimated number of attendees</p>
                </div>
                <div class="w-1/4">
                  <p class="border-b border-light-gray font-semibold">
                    {{ number_of_attendees }}</p>
                </div>
              </div>
              <div v-else class="flex mt-12 mb-12">
                <div class="pr-4">
                  <p class="uppercase font-normal">Estimated number of attendees: </p>
                </div>
                <div class="w-full">
                  <input v-model="number_of_attendees"
                        :class="{'error': (!$v.number_of_attendees.required || !$v.number_of_attendees.minValue) && isSubmitted}"
                        class="input w-full" type="number" @change="updatePrice">
                  <span v-if="!$v.number_of_attendees.required && isSubmitted"
                        class="block text-red-700 p-2">* Number of attendees is required.</span>
                  <span v-if="!$v.number_of_attendees.minValue && isSubmitted"
                        class="block text-red-700 p-2">* Minimum attendee must be 1.</span>
                </div>
              </div>
              <div class="mb-10 w-full">

                <div class="flex justify-center mt-3">
                  <div class="pr-4 w-1/4">
                    <p class="uppercase font-semibold text-xs opacity-50">Portal Price</p>
                  </div>
                  <div class="w-1/4">
                    <p class="border-b border-light-gray font-semibold">
                      {{ formatter(form.portal_price) }}</p>
                  </div>
                </div>

                <div class="flex justify-center mt-3">
                  <div class="pr-4 w-1/4">
                    <p class="uppercase font-semibold text-xs opacity-50">Estimated price</p>
                  </div>
                  <div class="w-1/4  ">
                    <p class="border-b border-light-gray font-semibold">
                      {{ formatter(form.price * this.number_of_attendees) }} = {{ formatter(form.price) }} X
                      {{ this.number_of_attendees }}
                    </p>
                  </div>
                </div>
                <div class="flex justify-center mt-3">
                  <div class="pr-4 w-1/4">
                    <p class="uppercase font-semibold text-xs opacity-50">Subtotal</p>
                  </div>
                  <div class="w-1/4">
                    <p class="border-b border-light-gray font-semibold">
                      {{ formatter(form.sub_total) }}</p>
                  </div>
                </div>
                <div class="flex justify-center mt-3">
                  <div class="pr-4 w-1/4">
                    <p class="uppercase font-semibold text-xs opacity-50">Delivery Expense</p>
                  </div>
                  <div class="w-1/4">
                    <p class="border-b border-light-gray font-semibold">
                      {{ formatter(form.delivery_expense) }}</p>
                  </div>
                </div>
                <div class="flex justify-center mt-3">
                  <div class="pr-4 w-1/4">
                    <p class="uppercase font-semibold text-xs opacity-50">Tax</p>
                  </div>
                  <div class="w-1/4">
                    <p class="border-b border-light-gray font-semibold">
                      {{ formatter(form.tax) }}</p>
                  </div>
                </div>
                <div class="flex justify-center mt-3">
                  <div class="pr-4 w-1/4">
                    <p class="uppercase font-semibold text-xs opacity-50">Total</p>
                  </div>
                  <div class="w-1/4">
                    <p class="border-b border-light-gray font-semibold">
                      {{ formatter(form.amount) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- If Produce an Event -->
          <div v-if="this.order.process == 1">
            <Activation />
          </div>

          <!-- bottom navigation -->
          <section class="mt-16">
            <div class="flex flex-col-reverse sm:flex-row justify-between">
              <button
                  class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                  @click="$emit('back')"
              >
                <span>Back</span>
              </button>
              <div>
                <button
                    class="btn btn-primary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto"
                    v-if="this.order.process != 1"
                    @click="submit"
                >
                  <span>Next</span>
                </button>

                <button
                    class="btn btn-primary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto"
                    v-if="this.order.process == 1"
                    @click="goToOrderDetails"
                >
                  <span>Next</span>
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>

      <!-- Right column -->
      <div class="m-2" v-if="this.order.process != 1">
        <InfoBox :showIcon="true">
          <p>
            Enter the anticipated number of attendees for your event to determine an estimated cost. You will not be
            charged until all orders are captured and finalized. This is for estimates only
          </p>
        </InfoBox>
      </div>
    </div>
  </div>
</template>

<script>

import Api from '@/api/api_v1.0'
import { ORDER_MENU_TYPE } from '@/utils/order-menu-type'
import { minValue, required } from 'vuelidate/lib/validators'
import InfoBox from '@/components/common/InfoBox'
import Activation from '@/views/orders/_uuid/edit/activation'

export default {
  name      : 'finalize',
  components: {
    InfoBox,
    Activation
  },
  data () {
    return {
      number_of_attendees     : 1,
      form                    : {
        amount          : 0,
        sub_total       : 0,
        tax             : 0,
        delivery_expense: 0,
        price           : 0,
        portal_price    : 0
      },
      tax_percent             : 0.079,
      delivery_expense_percent: 0.08,
      categories              : [],
      clicked                 : false
    }
  },
  computed   : {
    order () {
      return this.$store.state.currentEditingOrder
    },
    isSubmitted () {
      return this.clicked
    },
    canEstimate () {
      return this.order.payment_status === 'requires_capture'
    }
  },
  validations: {
    number_of_attendees: {
      required, minValue: minValue(1)
    }
  },
  async mounted () {
    await this.loadCategories()
  },
  methods: {
    async loadCategories () {
      this.progressLoading = true
      let price = 0
      await Api.getCategoriesForOrder(this.order.uuid, ORDER_MENU_TYPE.ALL).then(response => {

        this.categories = response
            .filter(category => category.items.length > 0)
            .map(category => {
              price += category.estimated_price
              return category
            })

        this.form.price = Math.round((price + Number.EPSILON) * 100) / 100
        this.number_of_attendees = this.order.estimated_attendees
        this.updatePrice()
        this.progressLoading = false
      }).catch(() => {
        this.progressLoading = false
      })
    },
    async loadPortalPrice () {
      let price = 0
      this.order.portals.forEach((portal) => {
        price += parseFloat(portal.price)
      })

      this.form.portal_price = Math.round((price + Number.EPSILON) * 100) / 100
    },
    async updatePrice () {
      await this.loadPortalPrice()

      this.form.sub_total = this.number_of_attendees * this.form.price + this.form.portal_price
      this.form.tax = this.tax_percent * this.form.sub_total
      this.form.delivery_expense = this.delivery_expense_percent * this.form.sub_total
      this.form.amount = this.form.sub_total + this.form.tax + this.form.delivery_expense
    },
    async goToOrderDetails () {
      this.$store.commit('setCurrentEditingOrder', this.order)
      this.$router.push(`/orders/${this.order.uuid}`)
    },
    async submit () {
      if (this.canEstimate) {
        this.$emit('submit')
        return true
      }

      if (this.$v.$invalid) {
        this.clicked = true
        return false
      }

      this.progressSaving = true
      const formData = new FormData
      formData.append('_method', 'PUT')
      formData.append('estimated_attendees', this.number_of_attendees)
      const orderResponse = await Api.updateOrderDetailsFormdata(
          this.order.uuid,
          formData,
      ).catch(e => {
        alert('ERROR! ' + e.message)
        return false
      })

      this.$store.commit('setCurrentEditingOrder', orderResponse.data)
      this.progressSaving = false

      this.$emit('submit')
    },
    back () {
      this.$emit('back')
    },
  },
}
</script>

<style scoped></style>
